<p-dialog [(visible)]="visible" (onHide)="closeModal()"
          [modal]="true" header="Formulario de Dirección"
          [style]="{width: '90vw', maxWidth: '900px'}" [draggable]="false"
          [resizable]="false" [closeOnEscape]="true" styleClass="direcciones-dialog">

  <div class="grid">
    <div class="form-section col-12">
      <h3 class="section-title font-normal text-capitalize
           mt-0 mb-2 font-16 color-blue-2 font-roboto-condensed">{{translations.direccionConstruida}}</h3>
      <div class="grid">
        <div class="col-12 p-2 border-round bg-gray-50">
          <p class="mb-0 mt-1 font-normal  font-principal">{{translations.direccionCompleta}}</p>
          <p class="font-bold my-1  font-principal">{{ getDireccionCompleta() || translations.direccionNoEspeficada }}</p>
        </div>
      </div>
    </div>
    <div class="col-12 ">
      <form [formGroup]="direccionForm">

        <!-- Sección Vía Principal -->
        <div class="form-section">
          <h3 class="section-title font-normal text-capitalize
           mt-0 mb-2 font-16 color-blue-2 font-roboto-condensed">{{translations.viaPrincipal}}</h3>
          <div class="grid">

            <div class="col-12 lg:col-4 ">
              <label for="barrio" class="block font-normal mb-0 ml-1">
                {{translations.barrio}}
                <span class="text-red-500">*</span>
              </label>
              <input id="barrio" type="text" pInputText formControlName="barrio"
                     class="w-full uppercase" (blur)="consultarDireccionesPosibles()"
                     placeholder="Ingrese el barrio"/>
              <ng-container *ngIf="direccionForm.get('barrio')?.invalid && direccionForm.get('barrio')?.touched">
                <app-form-group-error-message [control]="direccionForm.get('barrio')"/>
              </ng-container>
            </div>

            <!-- Campo Tipo de Vía -->
            <div class="col-12 md:col-6 lg:col-4 ">
              <label for="tipoVia" class="block font-normal mb-0 ml-1">
                {{translations.tipoVia}}
                <span class="text-red-500">*</span>
              </label>
              <p-dropdown id="tipoVia" [options]="tiposVia" optionLabel="descripcion" class="g-dropdown-decl"
                          formControlName="tipoVia" placeholder="Tipo de vía" (onChange)="consultarDireccionesPosibles()"
                          [showClear]="true" styleClass="w-full" appendTo="body"></p-dropdown>

              <ng-container *ngIf="direccionForm.get('tipoVia')?.invalid && direccionForm.get('tipoVia')?.touched">
                <app-form-group-error-message [control]="direccionForm.get('tipoVia')"/>
              </ng-container>

            </div>

            <!-- Campo Vía Principal -->
            <div class="col-12 md:col-6 lg:col-4 ">
              <label for="viaPrincipal" class="block font-normal mb-0 ml-1">
                {{translations.viaPrincipal}}
                <span class="text-red-500">*</span>
              </label>
              <input id="viaPrincipal" type="text"
                     pInputText formControlName="viaPrincipal" class="w-full uppercase"
                     placeholder="Ingrese la vía principal"/>
              <ng-container
                *ngIf="direccionForm.get('viaPrincipal')?.invalid && direccionForm.get('viaPrincipal')?.touched">
                <app-form-group-error-message [control]="direccionForm.get('viaPrincipal')"/>
              </ng-container>
            </div>

            <!-- Campo Letra -->
            <div class="col-12 md:col-4 lg:col-3 ">
              <label for="letra" class="block font-normal mb-0 ml-1">{{ translations.letra }}</label>
              <p-dropdown id="letra" [options]="letras" formControlName="letra" placeholder="Letra"
                          (onChange)="consultarDireccionesPosibles()"
                          class="g-dropdown-decl" optionLabel="abreviatura" [showClear]="true" styleClass="w-full"
                          appendTo="body"></p-dropdown>
            </div>
            <div class="col-12 md:col-4 lg:col-3 ">
              <label for="sufijo" class="block font-normal mb-0 ml-1">{{ translations.sufijo }}</label>
              <p-dropdown id="sufijo" [options]="sufijo" formControlName="sufijo" [placeholder]="translations.sufijo"
                         optionLabel="abreviatura" [showClear]="true" styleClass="w-full"
                          (onChange)="consultarDireccionesPosibles()"
                          class="g-dropdown-decl" appendTo="body"></p-dropdown>
            </div>

            <!-- Campo Letra Sufijo -->
            <div class="col-12 md:col-4 lg:col-3  ">
              <label for="letraSufijo" class="block font-normal mb-0 ml-1">{{translations.letraSufijo}}</label>
              <p-dropdown id="letraSufijo" [options]="letras" formControlName="letraSufijo" class="g-dropdown-decl"
                          [placeholder]="translations.letraSufijo" [showClear]="true" optionLabel="abreviatura"
                          (onChange)="consultarDireccionesPosibles()"
                          styleClass="w-full" appendTo="body"></p-dropdown>
            </div>

            <!-- Campo Cardinalidad -->
            <div class="col-12 md:col-4 lg:col-3  ">
              <label for="cardinalidad" class="block font-normal mb-0 ml-1">{{translations.cardinalidad}}</label>
              <p-dropdown id="cardinalidad" [options]="cardinalidad" formControlName="cardinalidad"
                          optionValue="literal" optionLabel="abreviatura" [placeholder]="translations.cardinalidad"
                          (onChange)="consultarDireccionesPosibles()"
                          [showClear]="true" styleClass="w-full" class="g-dropdown-decl"
                          appendTo="body"></p-dropdown>
            </div>
          </div>
        </div>

        <!-- Sección Vía Secundaria -->
        <div class="form-section mt-4">
          <h3 class="section-title  font-normal mt-0 mb-2 text-capitalize font-16 font-roboto-condensed color-blue-2">
            {{translations.viaSecundaria}}</h3>
          <div class="grid">

            <!-- Campo Vía Secundaria -->
            <div class="col-12 md:col-6 ">
              <label for="viaSecundaria" class="block font-normal mb-0 ml-1">{{translations.viaSecundaria}}</label>
              <input id="viaSecundaria" type="text" pInputText formControlName="viaSecundaria" class="w-full uppercase"
                     (blur)="consultarDireccionesPosibles()" placeholder="Ingrese la vía secundaria"/>
            </div>

            <!-- Campo Letra Secundaria -->
            <div class="col-12 md:col-6 ">
              <label for="letraSecundaria" class="block font-normal mb-0 ml-1">{{translations.letra}}</label>
              <p-dropdown id="letraSecundaria" [options]="letras" formControlName="letraSecundaria"
                          [placeholder]="translations.letra" [showClear]="true"
                          (onChange)="consultarDireccionesPosibles()"
                          optionLabel="descripcion" class="g-dropdown-decl"
                          styleClass="w-full" appendTo="body"></p-dropdown>
            </div>

            <!-- Campo Sufijo Secundario -->
            <div class="col-12 md:col-6 ">
              <label for="sufijoSecundario" class="block font-normal mb-0 ml-1">{{ translations.sufijo }}</label>
              <input id="sufijoSecundario" type="text" pInputText (blur)="consultarDireccionesPosibles()"
                     formControlName="sufijoSecundario" class="w-full uppercase" placeholder="Ingrese el sufijo"/>
            </div>

            <!-- Campo Cardinalidad Secundaria -->
            <div class="col-12 md:col-6 ">
              <label for="cardinalidadSecundaria" class="block font-normal mb-0 ml-1">{{ translations.cardinalidad }}</label>
              <p-dropdown id="cardinalidadSecundaria" optionLabel="descripcion" (onChange)="consultarDireccionesPosibles()"
                          [options]="cardinalidad" formControlName="cardinalidadSecundaria"
                          [placeholder]="translations.cardinalidad" [showClear]="true" class="g-dropdown-decl"
                          styleClass="w-full" appendTo="body"></p-dropdown>
            </div>
          </div>
        </div>

        <!-- Sección Complementos -->
        <div class="form-section mt-4">

          <div class="grid">
            <div class="col-12">
              <p-table [value]="complementosFormArray.controls" styleClass="p-datatable-sm custom-table-blue"
                    [scrollable]="true" scrollHeight="250px"   responsiveLayout="scroll">
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ translations.complemento }}</th>
                    <th>{{ translations.valorComplemento }}</th>
                    <th style="width: 4rem">
                      <button pButton (click)="agregarComplemento()"
                              class="p-button-rounded p-button-icon-only p-button-outlined">
                        <i class="pi pi-plus"></i>
                      </button>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-complemento let-i="rowIndex">
                  <tr [formGroup]="complemento">
                    <td>
                      <p-dropdown [options]="tiposComplemento" optionLabel="descripcion" (onChange)="consultarDireccionesPosibles()"
                                  formControlName="tipo" placeholder="Complemento" class="g-dropdown-decl"
                                  [showClear]="true" styleClass="w-full" appendTo="body"></p-dropdown>
                    </td>
                    <td>
                      <input type="text" pInputText formControlName="valor"
                             class="w-full uppercase" placeholder="Valor complemento"/>
                    </td>
                    <td>
                      <button pButton class="p-button-danger p-button-icon-only  p-button-outlined p-button-rounded"
                              (click)="eliminarComplemento(i)" [disabled]="complementosFormArray.length === 1">
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

      </form>
    </div>

  </div>

  <ng-template pTemplate="footer">
    <button pButton [label]="translations.btnCancelar" icon="pi pi-times" (click)="closeModal()"
            class="p-button-outlined p-button-secondary "></button>
    <button pButton [label]=" translations.btnGuardar" icon="pi pi-check" (click)="guardarDireccion()"
            [disabled]="direccionForm.invalid"></button>
  </ng-template>
</p-dialog>
